<template>
  <div>
    <div class="foot flex">
      <section>
        <img src="../../assets/images/0_img_logo_b.png" alt="" />
        <div class="text1">
          <span>{{ $t('footer.exploration') }}</span>
          <span style="margin-left: 10px">{{ $t('footer.innovation') }}</span>
        </div>
        <div class="text2">
          {{ $t('footer.pioneering') }}
          <span>|</span>
          {{ $t('footer.exploring') }}
          <span>|</span>
          {{ $t('footer.innovating') }}
          <span>|</span>
          {{ $t('footer.surpassing') }}
        </div>
      </section>
      <section class="flex right-sec">
        <div class="input">
          <div class="title-text">{{ $t('footer.subscribeNow') }}</div>
          <el-input v-model="value" placeholder=""></el-input>
          <el-button>{{ $t('footer.subscribe') }}</el-button>
        </div>
        <div class="info">
          <div class="title-text">{{ $t('footer.contacts') }}</div>
          <div class="text3">
            <span>{{ $t('footer.email') }}</span>info@seikaiyaku.com
          </div>
          <!-- <div class="text4"><span>Tel：</span>+81（0）90-6676-6996</div> -->
        </div>
      </section>
    </div>
    <div class="page-info">
      {{ $t('footer.copyright') }}
    </div>
  </div>
</template>
<script>
export default {
  name: "footView",
  data() {
    return {
      value: "",
    };
  },
};
</script>
<style lang="less" scoped>
@import "../../assets/css/app.less";
</style>
